// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1L7b-","description":"PatientConsentPreview_description__2f1Fs"};